export const CREATE = 'create';
export const CREATE_PATH = '/create';

export const EDIT = 'edit';
export const EDIT_PATH = '/edit';

export const VIEW = 'view';
export const VIEW_PATH = '/view';

